import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const CreativeControlSection = () => {
  return (
    <section className="py-20 lg:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left - Content (reversed order on desktop) */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="space-y-8 lg:order-1"
          >
            <h2 className="text-5xl lg:text-6xl font-bold leading-tight text-gray-900">
              Complete creative control
            </h2>

            <p className="text-xl text-gray-700 leading-relaxed">
              Patreon is your space to create what excites you most, rough or
              polished, big or small. Hundreds of thousands of creators use
              Patreon to share videos, podcasts, writing, art, music, recipes
              and more with their most passionate fans.
            </p>

            <div className="pt-4">
              <Link
                to="/product/create"
                className="inline-flex items-center px-8 py-3.5 text-base font-semibold text-white rounded-full transition-all duration-200 hover:opacity-90"
                style={{
                  background: '#FF424D',
                }}
              >
                Create on your terms
                <svg
                  className="ml-2 w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                  />
                </svg>
              </Link>
            </div>
          </motion.div>

          {/* Right - Image Grid */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative lg:order-2"
          >
            <div className="grid grid-cols-2 gap-4">
              {/* Top Left */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.1 }}
                className="relative rounded-2xl overflow-hidden shadow-lg"
              >
                <img
                  src="https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?w=400&h=500&fit=crop&q=80"
                  alt="Creator workspace"
                  className="w-full h-64 object-cover"
                />
              </motion.div>

              {/* Top Right */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="relative rounded-2xl overflow-hidden shadow-lg mt-8"
              >
                <img
                  src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=400&h=500&fit=crop&q=80"
                  alt="Creative process"
                  className="w-full h-64 object-cover"
                />
              </motion.div>

              {/* Bottom Left */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.3 }}
                className="relative rounded-2xl overflow-hidden shadow-lg"
              >
                <img
                  src="https://images.unsplash.com/photo-1485579149621-3123dd979885?w=400&h=500&fit=crop&q=80"
                  alt="Recording setup"
                  className="w-full h-64 object-cover"
                />
              </motion.div>

              {/* Bottom Right */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.4 }}
                className="relative rounded-2xl overflow-hidden shadow-lg mt-8"
              >
                <img
                  src="https://images.unsplash.com/photo-1487017159836-4e23ece2e4cf?w=400&h=500&fit=crop&q=80"
                  alt="Content creation"
                  className="w-full h-64 object-cover"
                />
              </motion.div>
            </div>

            {/* Floating Badge */}
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.5 }}
              className="absolute -bottom-6 left-1/2 transform -translate-x-1/2 bg-white rounded-full px-6 py-3 shadow-xl"
            >
              <p className="text-sm font-semibold">
                <span style={{ color: 'var(--patreon-btn-primary-bg)' }}>
                  200,000+
                </span>{" "}
                creators
              </p>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default CreativeControlSection;
